import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { ClickProvider } from '@make-software/csprclick-ui';
import { CsprClickInitOptions, CONTENT_MODE, WALLET_KEYS } from '@make-software/csprclick-core-types';
import App from './App';

const clickOptions: CsprClickInitOptions = {
  appName: 'CSPR.app',
  contentMode: CONTENT_MODE.IFRAME,
  providers: [WALLET_KEYS.CASPER_WALLET,
    WALLET_KEYS.LEDGER,
    WALLET_KEYS.METAMASK_SNAP,
    WALLET_KEYS.W3A_GOOGLE,
    WALLET_KEYS.W3A_APPLE
  ],
  appId: 'csprclick-template'
};

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <ClickProvider options={clickOptions}>
      <App />
    </ClickProvider>
  </React.StrictMode>
);
